export default __webpack_public_path__ + "static/media/Schooner Fernissa.28860140.jpg";